import React, { useState, useEffect } from "react";
import JsBarcode from "jsbarcode";
import { createCanvas } from "canvas";
import "../styles/armsform.css";

const Arms = () => {
    const [formData, setFormData] = useState({
        token_id: "E Arms - ",
        license_no: "",
        local_no: "",
        date: "",
        name: "",
        father_name: "",
        gender: "",
        cnic: "",
        address: "",
        profession: "",
        weapon: "",
        no: "",
        bore: "",
        cartridge_s: "",
        cartridge_a: "",
        validity: "",
        expiry: "",
        reason: "",
        status: "",
        phone_no: "",
    });

    const [message, setMessage] = useState(null);
    const [barcodeImage, setBarcodeImage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const generateBarcode = (tokenId) => {
        const canvas = createCanvas();
        JsBarcode(canvas, tokenId, { format: "CODE128" });
        return canvas.toDataURL("image/png");
    };

    useEffect(() => {
        if (formData.token_id) {
            setBarcodeImage(generateBarcode(formData.token_id));
        } else {
            setBarcodeImage(null);
        }
    }, [formData.token_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.token_id || !formData.local_no || !formData.date) {
            setMessage("Please fill in the required fields: Token ID, No, and Date.");
            return;
        }

        try {
            const response = await fetch("https://chaman.gob.pk/eac_backend/arms.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ action: "add", ...formData, barcode: barcodeImage, s_count: "save" }),
            });

            const result = await response.json();
            if (result.status === "success") {
                setMessage(result.message);
                setFormData({
                    token_id: "",
                    license_no: "",
                    local_no: "",
                    date: "",
                    name: "",
                    father_name: "",
                    gender: "",
                    cnic: "",
                    address: "",
                    profession: "",
                    weapon: "",
                    no: "",
                    bore: "",
                    cartridge_s: "",
                    cartridge_a: "",
                    validity: "",
                    expiry: "",
                    reason: "",
                    status: "",
                    phone_no: "",
                });
                setBarcodeImage(null);
                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 2000);
            } else {
                setMessage("Error: " + result.message);
            }
        } catch (error) {
            console.error("Error:", error);
            setMessage("An error occurred while submitting the form.");
        }
    };

    return (
        <div className="lc-form-container">
            <form className="lc-form" onSubmit={handleSubmit}>
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="token_id"
                                value={formData.token_id}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">S/O:</label>
                        <div className="lc-input-container">
                            <input
                                name="father_name"
                                value={formData.father_name}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Name of Retainer:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">CNIC:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cnic"
                                value={formData.cnic}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Phone No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="phone_no"
                                value={formData.phone_no}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">R/O:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Profession:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="profession"
                                value={formData.profession}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Weapon:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="weapon"
                                value={formData.weapon}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="no"
                                value={formData.no}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>

                </div>

                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Bore:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="bore"
                                value={formData.bore}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Cartridge at a time:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cartridge_s"
                                value={formData.cartridge_s}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Cartridge Annually:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cartridge_a"
                                value={formData.cartridge_a}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Validity:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="validity"
                                value={formData.validity}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Expiry:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="expiry"
                                value={formData.expiry}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">License No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="license_no"
                                value={formData.license_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Letter No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="local_no"
                                value={formData.local_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Date:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Status:</label>
                        <div className="lc-input-container">
                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className="lc-select"
                            >
                                <option value="" disabled>Select Status</option>
                                <option value="Recieved">Recieved</option>
                                <option value="Ready">Ready</option>
                            </select>
                        </div>
                    </div>
                </div>
                <button type="submit" className="lc-submit-btn">Save</button>
            </form>

            {/* {barcodeImage && (
                <div className="lc-barcode-container">
                    <img src={barcodeImage} alt="Barcode" className="lc-barcode" />
                </div>
            )} */}

            {showPopup && (
                <div className="lc-popup">
                    Data saved successfully!
                </div>
            )}
        </div>
    );
};

export default Arms;